'use client';

import { useIsLaptop } from '@/_hooks/useBreakpoint';
import { authActions } from '@/_store/auth/auth.slice';
import {
  PopoverBody,
  PopoverContent,
  PopoverRoot,
  PopoverTrigger,
} from '@/components/ui/popover';
import { Link, useRouter } from '@/i18n/navigation';
import { Button, Flex, IconButton, Stack, Text, useDisclosure } from '@chakra-ui/react';
import { useTranslations } from 'next-intl';
import { useDispatch, useSelector } from 'react-redux';
import { userOptions } from './_constants';
import { IRedux } from '@/_store/types';
import Auth from '@/_components/Auth';
import { useState } from 'react';
import { checkoutActions } from '@/_store/checkout/checkout.slice';
import { LuLogIn } from 'react-icons/lu';
import { HiChevronRight } from 'react-icons/hi';
import ProfileIcon from '@/_assets/icon-components/Profile';
import Image from 'next/image';
import logoutIcon from '@/shared/assets/svg/logout.svg';

const User = () => {
  const [isAuth, setIsAuth] = useState(false);

  const { user } = useSelector((state: IRedux) => state.auth);

  const t = useTranslations();
  const router = useRouter();
  const dispatch = useDispatch();
  const { open, onOpen, onClose } = useDisclosure();
  const isLaptop = useIsLaptop();

  const handleRemoveData = () => {
    dispatch(authActions.logout());
    dispatch(checkoutActions.clear());
    router.push('/');
  };

  return (
    <>
      {user?.id ? (
        <PopoverRoot
          open={open}
          onOpenChange={(e) => (e.open ? onOpen() : onClose())}
        >
          <PopoverTrigger asChild>
            <IconButton
              size='xl'
              color='text'
              rounded='full'
              bg='background'
              variant='subtle'
              onClick={onOpen}
            >
              <ProfileIcon color='currentColor' />
            </IconButton>
          </PopoverTrigger>
          <PopoverContent
            bg='background.card'
            rounded={12}
            maxW='250px'
            overflow='hidden'
            border={'1px solid'}
            borderColor={'background'}
          >
            <PopoverBody p={0} color='text'>
              <Stack gap={0}>
                <Link href={'/profile'}>
                  <Flex
                    p={3}
                    gap={2}
                    fontSize={14}
                    cursor='pointer'
                    fontWeight={600}
                    onClick={onClose}
                    alignItems='center'
                    justifyContent='space-between'
                    _hover={{ bg: 'background' }}
                    borderBottom={'1px solid'}
                    borderColor={'background'}
                  >
                    <Text>{user?.name || ''}</Text>
                    <HiChevronRight size={20} />
                  </Flex>
                </Link>
                {userOptions.map(({ icon, label, link }) => (
                  <Link key={label} href={link}>
                    <Flex
                      p={3}
                      gap={2}
                      fontSize={14}
                      cursor='pointer'
                      fontWeight={500}
                      onClick={onClose}
                      alignItems='center'
                      _hover={{ bg: 'background' }}
                    >
                      {icon}
                      {t(label)}
                    </Flex>
                  </Link>
                ))}
                <Flex
                  p={3}
                  gap={2}
                  fontSize={14}
                  cursor='pointer'
                  fontWeight={500}
                  alignItems='center'
                  onClick={handleRemoveData}
                  _hover={{ bg: 'background' }}
                >
                  <Image src={logoutIcon} width={20} height={20} alt='logout' />
                  <Text>{t('logout')}</Text>
                </Flex>
              </Stack>
            </PopoverBody>
          </PopoverContent>
        </PopoverRoot>
      ) : isLaptop ? (
        <IconButton
          aria-label='Log in'
          title='Log in'
          variant='subtle'
          rounded='full'
          size='xl'
          onClick={() => setIsAuth(true)}
          color='text'
          bg='background'
        >
          <LuLogIn color='currentColor' />
        </IconButton>
      ) : (
        <Button
          size={'xl'}
          rounded='full'
          onClick={() => setIsAuth(true)}
          bg='background'
          color='text'
          variant={'plain'}
        >
          {t('login')}
        </Button>
      )}
      <Auth
        open={isAuth}
        onClose={() => setIsAuth(false)}
        onLastConfirm={() => { }}
      />
    </>
  );
};

export default User;
